import {TextField, TextFieldProps} from '@mui/material';
import React, {useState} from 'react';
import {styled} from "@mui/material/styles";

const AppInputTextField = styled(TextField)(() => ({
  marginBottom: '0.6rem',
  '& input': {
    width: '100%'
  },
  '& label': {
    fontSize: '1em',
    fontWeight: 400,
    fontFamily: 'Inter',
    letterSpacing: '.05em',
    color: 'rgba(0, 0, 0, 0.38)',
    lineHeight: 'normal',
  }
}));

interface TextFieldWithDirtyValidationProps extends Omit<TextFieldProps, 'variant'> {
  showHelperText?: boolean;
  variant?: TextFieldProps['variant'];
}

const TextFieldWithDirtyValidation = React.forwardRef<HTMLInputElement, TextFieldWithDirtyValidationProps>(
  (props, ref) => {
    const [isDirty, setIsDirty] = useState(false);
    // Default to the underlined "standard" look for existing callers; allow opt-in to outlined.
    // Destructure showHelperText so it isn't spread onto the underlying DOM element.
    const { variant = 'standard', showHelperText, ...rest } = props;

    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
      setIsDirty(true);
      if (props.onBlur) {
        props.onBlur(event);
      }
    };

    return (
      <AppInputTextField
        {...rest}
        inputRef={ref}
        onBlur={handleBlur}
        error={isDirty && props.error}
        helperText={(isDirty && props.error) || showHelperText ? props.helperText : undefined}
        variant={variant}
      />
    );
  }
);

TextFieldWithDirtyValidation.displayName = 'TextFieldWithDirtyValidation';


export default TextFieldWithDirtyValidation;
